import { expect } from '@open-wc/testing';
import { html } from 'lit';
import { ref } from 'lit/directives/ref.js';
import { styleMap } from 'lit/directives/style-map.js';
import { asView } from './as-view.js';
import { spread } from './utils/spread.js';
import { fixture } from './view-testing.js';

describe('View', () => {
  const [MyDiv] = asView({
    Props: class {
      text = '';
    },
    mapBuilder: MyDivBuilder => (text: string) => MyDivBuilder().text(text),
    template({ text }, { bindings, styles, elementRef }) {
      return html`<div
        style="${styleMap(styles)}"
        ${spread(bindings)}
        ${ref(elementRef)}
      >
        ${text}
      </div>`;
    },
  });

  describe('attr', () => {
    it('sets boolean attribute when true', async () => {
      const el = await fixture(MyDiv('test').attr('open', true));
      expect(el.hasAttribute('open')).to.be.true;
    });

    it('does not set boolean attribute when false', async () => {
      const el = await fixture(MyDiv('Test').attr('open', false));
      expect(el.hasAttribute('open')).to.be.false;
    });
  });

  describe('className', () => {
    it('sets class attribute', async () => {
      const el = await fixture(MyDiv('Test').className('cool item__cold'));
      expect(el.className).to.eq('cool item__cold');
    });
  });
});
